import { render } from "./nav-menu.vue?vue&type=template&id=5bf25286&scoped=true"
import script from "./nav-menu.vue?vue&type=script&lang=js"
export * from "./nav-menu.vue?vue&type=script&lang=js"

import "./nav-menu.vue?vue&type=style&index=0&id=5bf25286&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf25286"]])

export default __exports__